import React from "react";
import { WEBSITE_DATA } from "../../constants/dashboard";
import BackArrow from "../../assets/backArrow.svg";
import { useNavigate } from "react-router-dom";
import "./style.css";

const Warning = () => {
  const navigate = useNavigate();
  return (
    <>
      <div className="head">
        <img
          src={BackArrow}
          className="back"
          alt="back"
          onClick={() => navigate("/")}
        />
        <img id="img" src={WEBSITE_DATA?.logo} alt="title" />
      </div>

      <div className="warning">
        <p className="text">Details to be unveiled soon!</p>
      </div>
    </>
  );
};

export default Warning;
